<h2 mat-dialog-title>
  <mat-icon style="vertical-align: middle;">picture_as_pdf</mat-icon>
  Export to PDF
</h2>

<mat-dialog-content>
  <p class="schedule-name">{{ data.scheduleName }}</p>

  <div class="form-section">
    <h3>View Mode</h3>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Group by</mat-label>
      <mat-select [(ngModel)]="options.viewMode">
        <mat-option value="perDay">Per Day</mat-option>
        <mat-option value="perField">Per Field/Resource</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-section">
    <h3>Paper Size</h3>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Size</mat-label>
      <mat-select [(ngModel)]="options.paperSize">
        <mat-option value="A4">A4</mat-option>
        <mat-option value="LETTER">Letter (US)</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-section">
    <h3>Options</h3>
    <div class="checkbox-group">
      <mat-checkbox [(ngModel)]="options.includeBranding">
        Include organization name
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="options.includeHeaders">
        Include page headers
      </mat-checkbox>
      <div class="nested-options">
        <mat-checkbox
          [(ngModel)]="options.includeScheduleName"
          [disabled]="!options.includeHeaders">
          Schedule name
        </mat-checkbox>
        <mat-checkbox
          [(ngModel)]="options.includeVersion"
          [disabled]="!options.includeHeaders">
          Version info
        </mat-checkbox>
        <mat-checkbox
          [(ngModel)]="options.includePageNumbers"
          [disabled]="!options.includeHeaders">
          Page numbers
        </mat-checkbox>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="onExport()">
    <mat-icon>download</mat-icon>
    Export PDF
  </button>
</mat-dialog-actions>
